import { createContext, useContext, useEffect, useState } from "react";
import { translations, get } from "@/i18n";

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState("en");

    useEffect(() => {
        document.documentElement.lang = lang;
    }, [lang]);

    const t = (path) =>
        get(translations[lang], path) ?? get(translations.en, path) ?? path;

    const toggle = () => setLang((l) => (l === "en" ? "es" : "en"));

    return (
        <LangContext.Provider value={{ lang, setLang, toggle, t, isEs: lang === "es" }}>
            {children}
        </LangContext.Provider>
    );
};

export const useLang = () => useContext(LangContext);
